import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage, set_ep1_lastVisitFrame } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import './F19.css';
import backIcon2 from '../../../Assests/backIcon2.svg'

function Frame19() {
    let [isLoading, setIsLoading] = useState(false);
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);
    useEffect(() => {
        setTimeout(function () { setIsLoading(false) }, 100);

    }, []);

    if (isLoading === true) {
        return (<div className="F18_image"></div>)
    } else {
        return (
            <div className="F19_imageAnimate">
                <img onClick={() => { dispatch(pageDown()) }} className='backButton' src={backIcon2} alt="React Logo" height={30} />
                <div className="F19_entryBox">
                    <div className="F19_paragraph">{
                        language === 'english' ?
                            <p className="F19_paragraphEnglish">When Saira opens the door, her elder sister Sofia notices visible distress on Saira’s face and behind her she could see bloodstains on her bedsheet.</p>
                            :
                            <p className="F19_paragraphUrdu">سائرا جب دروازہ کھولتی ہے تو صوفیہ کو سائرا کے چہرے پر پریشانی نظر آتی ہے اور پھر اس کی نظر بستر پر خون کے دھبوں پر جاتی ہے۔</p>
                    }
                    </div>

                    <div className="F19_timeline">
                        <div className='F19_timelineBar'>
                            <div className='F19_timelineFill'></div>
                            <span className='F19_timelineText'>14/16</span>
                        </div>
                    </div>

                    <div className="F19_nextFrames">
                        <div className="F19_nextFrame1"></div>
                        <div className="F19_nextFrame2"></div>
                        <div className="F19_nextFrame3"></div>
                    </div>

                    <div className='F19_buttonDiv'>
                        <button onClick={() => { dispatch(pageUp()); dispatch(set_ep1_lastVisitFrame(14)) }} className='F19_button'>
                            {language === 'english' ? 'Continue' : 'آگے  جائیں'}
                        </button>
                    </div>

                </div>
            </div>
        )
    }
}

export default Frame19;